import React from 'react';
import EpikLogo from '../../Res/epic-standard-log.png';

const CreditApplicationSection = ({ billingAddress, fax, companyField, proposalData }) => {
  return (
    <div className="loa-doc-page">
      <img src={EpikLogo} className="epik-logo" />
      <h3 className="loa-doc-card-title">Credit Application</h3>

      <span className="credit-app-table-caption">
        <b>Applicant Information:</b>
      </span>
      <div className="credit-app-table">
        <div className="credit-app-table-row">
          <div className="credit-app-table-cell credit-app-table-cell-50">
            <span className="credit-app-table-cell-title">Business Legal Name:</span>
            <span>{companyField && companyField.companyName}</span>
          </div>
          <div className="credit-app-table-cell credit-app-table-cell-50">
            <span className="credit-app-table-cell-title">Phone Number:</span>
            <span>{companyField ? companyField.contact : ''}</span>
          </div>
        </div>
        <div className="credit-app-table-row">
          <div className="credit-app-table-cell credit-app-table-cell-50">
            <span className="credit-app-table-cell-title">Contact’s Name:</span>
            <span></span>
          </div>
          <div className="credit-app-table-cell credit-app-table-cell-50">
            <span className="credit-app-table-cell-title">Fax:</span>
            <span>{fax || ''}</span>
          </div>
        </div>
        <div className="credit-app-table-row">
          <div className="credit-app-table-cell">
            <span className="credit-app-table-cell-title">Main business office address:</span>
            <span>
              {billingAddress ? billingAddress.address1 + ' ' + billingAddress.address2 : ''}
            </span>
          </div>
        </div>
        <div className="credit-app-table-row">
          <div className="credit-app-table-cell credit-app-table-cell-50">
            <span className="credit-app-table-cell-title">City:</span>
            <span>{billingAddress ? billingAddress.city : ''}</span>
          </div>
          <div className="credit-app-table-cell">
            <span className="credit-app-table-cell-title">State:</span>
            <span>{billingAddress ? billingAddress.state : ''}</span>
          </div>
          <div className="credit-app-table-cell">
            <span className="credit-app-table-cell-title">Zip:</span>
            <span>{billingAddress ? billingAddress.zip : ''}</span>
          </div>
          <div className="credit-app-table-cell"></div>
        </div>
        <div className="credit-app-table-row">
          <div className="credit-app-table-cell">
            <span className="credit-app-table-cell-title">Email:</span>
            <span>{companyField ? companyField.email : ''}</span>
          </div>
        </div>
        <div className="credit-app-table-row">
          <div className="credit-app-table-cell credit-app-table-cell-25">
            <span className="credit-app-table-cell-title">Years in Business:</span>
          </div>
          <div className="credit-app-table-cell credit-app-table-cell_br-none credit-app-table-cell_col">
            <span className="credit-app-table-cell-title">Corporation</span>
            <div className="credit-app-table-cell-checkbox" />
          </div>
          <div className="credit-app-table-cell credit-app-table-cell_br-none credit-app-table-cell_col">
            <span className="credit-app-table-cell-title">LLC</span>
            <div className="credit-app-table-cell-checkbox" />
          </div>
          <div className="credit-app-table-cell credit-app-table-cell_br-none credit-app-table-cell_col">
            <span className="credit-app-table-cell-title">Proprietorship</span>
            <div className="credit-app-table-cell-checkbox" />
          </div>
          <div className="credit-app-table-cell credit-app-table-cell_br-none credit-app-table-cell_col">
            <span className="credit-app-table-cell-title">Partnership</span>
            <div className="credit-app-table-cell-checkbox" />
          </div>
          <div className="credit-app-table-cell credit-app-table-cell_br-none credit-app-table-cell_col">
            <span className="credit-app-table-cell-title">Non-Profit</span>
            <div className="credit-app-table-cell-checkbox" />
          </div>
          <div className="credit-app-table-cell credit-app-table-cell_br-none credit-app-table-cell_col">
            <span className="credit-app-table-cell-title">Other (Please list)</span>
          </div>
        </div>
        {/* hidden */}
        <div className="credit-app-table-row" hidden>
          <div className="credit-app-table-cell credit-app-table-cell-50">
            <span className="credit-app-table-cell-title">Tax ID:</span>
            <span></span>
          </div>
          <div className="credit-app-table-cell credit-app-table-cell-50">
            <span className="credit-app-table-cell-title">State of Incorporation:</span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditApplicationSection;
